import { constraints, datatypes, inputTypes } from "data/globalData";

export const tableColumns = {
	trims_id: {
		name: "Trims Id",
		key: "trims_id",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	category: {
		name: "Category",
		key: "category",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	description: {
		name: "Description",
		key: "description",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},

	trim_cost: {
		name: "Trim Cost",
		key: "trim_cost",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	no_of_pcs_per_carton: {
		name: "No Of Pcs Per Carton",
		key: "no_of_pcs_per_carton",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.NUMBER.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
	supplier: {
		name: "Supplier",
		key: "supplier",
		input_type: inputTypes.ENTER.key,
		data_type: datatypes.STRING.key,
		constraints: { NOTNULL: false, DISPLAY: true },
	},
};

export const dummyDynamicTrimsTableData = [
	{
		id: 1,
		trims_id: "1234",
		category: "Carton box",
		description: "CARTON BOX 51*37*45.5",
		trim_consumption: 2.2,
		garment_qty_per_trim_consumption: 30,
		trim_price: 40,
		price_per_garment: 2,
		consumption_per_garment: 1,
		value: 341,
		supplier: "MANOHAR FILAMENT",
		qty: 1,
		garment_qty: 1,
	},
	{
		id: 2,
		trims_id: "1234",
		category: "Carton box",
		description: "CARTON BOX 51*37*45.5",
		trim_consumption: 2.2,
		garment_qty_per_trim_consumption: 30,
		consumption_per_garment: 1,
		trim_price: 40,
		price_per_garment: 2,
		value: 341,
		supplier: "MANOHAR FILAMENT",
		qty: 1,
		garment_qty: 1,
	},
];

export const defaultTotalRow = {
	id: "TOTAL",
	trims_id: "TOTAL",
	category: " Carton & Tape total",
	consumption: 2.2,
	price: 155.0,
	value: 341,
};

export const checkForTotalColumn = (row) => {
	if (row.id === "TOTAL" || row.trims_id === "TOTAL" || row?.[tableColumns.category.key] === "TOTAL") return true;
	return false;
};
export const calculateTotalRow = (allRows) => {
	let value = 0;
	allRows?.forEach((row) => {
		if (!isNaN(row?.[tableColumns.value.key])) value += +row?.[tableColumns.value.key];
	});
	return { ...defaultTotalRow, [tableColumns.value.key]: value };
};
